export function getView(value) {
  return !value || value.length === 0 ? 'Unset' : 'Set'
}
